import React from 'react';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/HeroSection';
import RutasSection from './components/sections/RutasSection';
import AboutSection from './components/sections/AboutSection';
import AIChat from './components/features/AIChat';

function App() {
  return (
    <div className="App">
      <Layout>
        <HeroSection />
        <RutasSection />
        <AboutSection />
      </Layout>
      <AIChat />
    </div>
  );
}

export default App;
